import { smrApi } from '@/utils/axios-config'
const apiBase = 'smr-core';

export default {
    route(params) {
        return smrApi.post(`${apiBase}/route`, params)
    },
    staticMap(params) {
        return smrApi.post(`${apiBase}/map`, params, {
            responseType: 'arraybuffer'
        })
    },
    testRoute(params) {
        params.waypoints = [
            // { "name": "Villach" },
            // { "name": "München" }
            { "name": "Wien" },
            { "name": "Graz" }
            // { "name": "Laa" },
            // { "name": "Gerasdorf" }
        ];
        return smrApi.post(`${apiBase}/test-route`, params)
    },
}